<script>
import LanguageFormSettingView from "@/pages/systemSetting/components/LanguageFormSettingView.vue";
import LanguageAreaSettingView from "@/pages/systemSetting/components/LanguageAreaSettingView.vue";
import LanguageVisitorSettingView from "@/pages/systemSetting/components/LanguageVisitorSettingView.vue";
import LanguageEmployeeSettingView from "@/pages/systemSetting/components/LanguageEmployeeSettingView.vue";
import LanguageOtherSettingView from "@/pages/systemSetting/components/LanguageOtherSettingView.vue";

export default {
  name: "LauncherSettingPage",
  components: {LanguageFormSettingView, LanguageAreaSettingView, LanguageVisitorSettingView, LanguageEmployeeSettingView, LanguageOtherSettingView},
  data() {
    return {
      activeName: "first",
    };
  },
  methods: {
    onTabChange() {
      if (this.activeName === "first") {
        this.requiredForm1();
      }
    },
    requiredForm1() {

    },
  }, // end of methods
}
</script>

<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="onTabChange">
      <el-tab-pane label="表单设置" name="first">
        <LanguageFormSettingView v-if="activeName === 'first'"></LanguageFormSettingView>
      </el-tab-pane>
      <el-tab-pane label="区域设置" name="second">
        <LanguageAreaSettingView v-if="activeName === 'second'"></LanguageAreaSettingView>
      </el-tab-pane>
      <el-tab-pane label="访客信息" name="third">
        <LanguageVisitorSettingView v-if="activeName === 'third'"></LanguageVisitorSettingView>
      </el-tab-pane>
      <el-tab-pane label="员工信息" name="four">
        <LanguageEmployeeSettingView v-if="activeName === 'four'"></LanguageEmployeeSettingView>
      </el-tab-pane>
      <el-tab-pane label="其它设置" name="five">
        <LanguageOtherSettingView v-if="activeName === 'five'"></LanguageOtherSettingView>
      </el-tab-pane>
    </el-tabs>


  </div>

</template>

<style scoped lang="less">

</style>
